<div class="issuer-definition-workspace" *ngIf="issuerManaged && variantService.activeVariant; else legacyVariant">
    <header class="issuer-definition-header">
        <div class="issuer-definition-copy">
            <p class="issuer-eyebrow">Credential Definition</p>
            <h1>{{ certificationService.activeItem.name }}</h1>
            <p class="issuer-description">
                {{ certificationService.activeItem.description || 'JSON-Schema für eine wallet-basierte Organisationszertifizierung.' }}
            </p>
        </div>
        <div class="issuer-header-actions">
            <button mat-stroked-button color="primary" class="issuer-admin-action"
                *ngIf="canManageIssuerCertification"
                [disabled]="issuerActionLoading" (click)="routeEditIssuerDefinition()">
                <mat-icon>edit</mat-icon>
                Bearbeiten
            </button>
            <button mat-stroked-button color="warn" class="issuer-admin-action"
                *ngIf="canManageIssuerCertification"
                [disabled]="issuerActionLoading" (click)="deleteIssuerDefinition()">
                <mat-icon>delete</mat-icon>
                Löschen
            </button>
            <button mat-raised-button color="primary" class="issuer-primary-action"
                *ngIf="activeVersion" [disabled]="issuerActionLoading"
                (click)="productCertification(activeVersion.id)">
                {{ canManageIssuerCertification ? 'Unternehmen zertifizieren' : 'Zertifizierte Unternehmen' }}
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </div>
    </header>

    <div class="issuer-definition-layout">
        <main class="issuer-schema-section">
            <div class="issuer-section-heading">
                <div>
                    <p class="issuer-section-kicker">Schema</p>
                    <h2>{{ variantService.activeVariant.name }}</h2>
                </div>
                <span class="issuer-node-count">{{ issuerSchemaNodes.length }} Felder</span>
            </div>
            <p class="issuer-section-description">
                Die Struktur, die beim Attestieren einer Organisation als Eingabeformular verwendet wird.
            </p>

            <div class="issuer-schema-list" *ngIf="issuerSchemaNodes.length; else emptyIssuerSchema">
                <div class="issuer-schema-node" *ngFor="let node of issuerSchemaNodes"
                    [style.padding-left.rem]="1 + node.depth * 1.5">
                    <div class="issuer-node-line">
                        <mat-icon class="issuer-node-icon">
                            {{ node.type === 'object' ? 'account_tree' : node.type === 'number' ? 'tag' : 'text_fields' }}
                        </mat-icon>
                        <div class="issuer-node-name">
                            <strong>{{ node.name }}</strong>
                            <span>{{ node.path }}</span>
                        </div>
                    </div>
                    <span class="issuer-node-type">{{ node.type | uppercase }}</span>
                    <span class="issuer-node-constraint">
                        <ng-container *ngIf="node.childCount">{{ node.childCount }} Felder</ng-container>
                        <ng-container *ngIf="!node.childCount && (node.min != null || node.max != null)">
                            {{ node.min != null ? 'Min. ' + node.min : '' }}
                            {{ node.max != null ? 'Max. ' + node.max : '' }}
                        </ng-container>
                        <ng-container *ngIf="!node.childCount && node.min == null && node.max == null">–</ng-container>
                    </span>
                </div>
            </div>
            <ng-template #emptyIssuerSchema>
                <div class="issuer-schema-empty">
                    <mat-icon>schema</mat-icon>
                    <div>
                        <strong>Noch keine JSON-Nodes</strong>
                        <p>Bearbeiten Sie die Credential Definition, um das Organisationsformular zu strukturieren.</p>
                    </div>
                </div>
            </ng-template>
        </main>

        <aside class="issuer-definition-inspector">
            <p class="issuer-section-kicker">Wallet-Konfiguration</p>
            <dl>
                <div>
                    <dt>Format</dt>
                    <dd>{{ certificationService.activeItem.issuerCredentialFormat }}</dd>
                </div>
                <div>
                    <dt>Gültigkeit</dt>
                    <dd>{{ issuerValidityLabel }}</dd>
                </div>
                <div>
                    <dt>Attestierungen</dt>
                    <dd>{{ certificationService.activeItem.issuerAttestationIds?.length || 0 }}</dd>
                </div>
                <div class="issuer-definition-id">
                    <dt>Definition ID</dt>
                    <dd>{{ certificationService.activeItem.issuerCredentialDefinitionId }}</dd>
                </div>
            </dl>
            <div class="issuer-wallet-note">
                <mat-icon>verified_user</mat-icon>
                <p>Änderungen werden über Issuer Service direkt mit dem Wallet synchronisiert.</p>
            </div>
        </aside>
    </div>
</div>

<ng-template #legacyVariant>
<div class="grid" *ngIf="variantService.activeVariant">
    <div>
        <div class="mini-grid-headline">
            <h1>{{ variantService.activeVariant.name }}</h1>
            <squared-button *ngIf="!certificationService.activeItem.issuerManaged" class="edit-btn" [label]="'Variante bearbeiten'"
                (click)="routeEditVariant()"></squared-button>
            <squared-button *ngIf="!certificationService.activeItem.issuerManaged" class="del-btn" [color]="'btn_red'" [label]="'Variante löschen'"
                (click)="deleteVariant()"></squared-button>
        </div>

        <div class="versionTable-row-header">
            <h4 class="version-table-first-column grid-item">Name</h4>
            <h4 class="grid-item">Status</h4>
            <h4 class="version-table-title grid-item">Vorgängerversion</h4>
        </div>
        <ng-container *ngFor="
                let version of this.variantService.activeItem
                    .certificationVariantVersions
            ">
            <div class="versionTable-row" [class]="{
                    highlight:
                        activeVersion != null && version.id == activeVersion.id
                }" (click)="showInfoOfVersion(version.id)">
                <p class="version-table-first-column grid-item">
                    {{ version.name }}
                </p>
                <p class="grid-item">
                    {{ version.status }}
                </p>
                <p class="grid-item">
                    {{
                    version.previousVersion === null
                    ? '-'
                    : showPrevious(version.previousVersion)
                    }}
                </p>
                <div *ngIf="!certificationService.activeItem.issuerManaged" class="mini-hex-button" [matTooltip]="'Version löschen'" [matTooltipPosition]="'below'"
                    matTooltipClass="tooltip">
                    <hexagon [icon]="'minus'" [hover]="true" [outerColor]="'var(--app-primary)'"
                        (click)="deleteVariantVersionPress(version.id)">
                    </hexagon>
                    <!------------------------------------------>
                </div>
                <div *ngIf="!certificationService.activeItem.issuerManaged" class="mini-hex-button" [matTooltip]="'Version bearbeiten'" [matTooltipPosition]="'below'"
                    matTooltipClass="tooltip">
                    <hexagon [icon]="'edit'" [hover]="true" [outerColor]="'var(--app-primary)'"
                        (click)="editVariantVersionPress(version.id)"></hexagon>
                </div>
                <rounded-button *ngIf="version.status === 'ACTIVE'"
                    [label]="certType == 'ONTOLOGY_CERT'
                        ? (certificationService.activeItem.issuerManaged && !canManageIssuerCertification
                            ? 'Zertifizierte Unternehmen'
                            : 'Unternehmen zertifizieren')
                        : 'Produkte zertizifieren'"
                    (click)="productCertification(version.id)"></rounded-button>
                <div *ngIf="!certificationService.activeItem.issuerManaged" class="mini-hex-button" [matTooltip]="'Nachfolgeversion erstellen'" [matTooltipPosition]="'below'"
                    matTooltipClass="tooltip">
                    <hexagon [icon]="'plus'" [hover]="true" [outerColor]="'var(--app-primary)'"
                        (click)="addVariantVersionPress(version.id)">
                    </hexagon>
                </div>
            </div>
        </ng-container>
    </div>
    <app-version-info-box style="margin-top: 2em" *ngIf="activeVersion" [version]="activeVersion"
        [certType]="certType"></app-version-info-box>
</div>
</ng-template>
